{
  "_comment": "[CI-LOCKED] Вміст цього файлу заблоковано. Внески вітаються, але перевірка змін може зайняти певний час.",
  "ACCESS_KEY_ALT": "Alt + Shift + $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control + Option + $1",
  "ACTIVITY_BOT_SAID_ALT": "Бот $1 каже:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Агент",
  "ACTIVITY_YOU_SAID_ALT": "Ви кажете:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Бот вкладає:",
  "ACTIVITY_CODE_ALT": "Зразок коду: $1",
  "ACTIVITY_CONTENT_CAUTION": "Вміст, створений штучним інтелектом, може бути неправильним",
  "ACTIVITY_CODE_CAUTION": "Код, створений ШІ. Перевірте й використовуйте обережно",
  "ACTIVITY_ERROR_BOX_TITLE": "Повідомлення про помилку",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Клацніть, щоб взаємодіяти.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Повідомлення інтерактивне.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Повідомлення містить одне або кілька посилань.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Помилка надсилання.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Ви вкладаєте:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 вкладення.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 вкладення.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 вкладення.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 вкладення.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 вкладення.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Не вдалося надіслати. [Повторити][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Надсилання",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Надіслано о $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Щойно",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Годину тому",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Хвилину тому",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Сьогодні",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Учора",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Помилка аналізу адаптивної картки",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Помилка відображення адаптивної картки",
  "ATTACHMENT_AUDIO": "Аудіокліп.",
  "ATTACHMENT_CARD": "Картка: $1 $2 $3",
  "ATTACHMENT_FILE": "Файл: $1",
  "ATTACHMENT_IMAGE": "Зображення",
  "ATTACHMENT_TEXT": "Текст: $1",
  "ATTACHMENT_VIDEO": "Відеокліп",
  "AVATAR_ALT": "Аватар $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Далі",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Назад",
  "CITATION_MODEL_DIALOG_ALT": "Цитування",
  "CLOSE_BUTTON_ALT": "Закрити",
  "COLLAPSIBLE_GROUPING_TITLE": "Обробка…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Це відображається, коли бот складає відповіді у групі, якщо анотація не надана.",
  "COLLAPSE_BUTTON_LESS": "Показати менше",
  "COLLAPSE_BUTTON_LESS.comment": "Це текст шевронної кнопки для згортання групи повідомлень. Коли користувач натискає кнопку, група повідомлень згортається.",
  "COLLAPSE_BUTTON_MORE": "Показати більше",
  "COLLAPSE_BUTTON_MORE.comment": "Це текст шевронної кнопки для розширення групи повідомлень. Коли користувач натискає кнопку, група повідомлень розширюється.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Підключено",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Підключення…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Не вдалося підключити.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Підключення до мережі перервано. Відновлення підключення...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Помилка відображення. Перевірте консоль або зверніться до розробника бота.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Підключення триває більше часу, ніж зазвичай.",
  "CONNECTIVITY_STATUS_ALT": "Стан підключення: $1",
  "COPY_BUTTON_TEXT": "Копіювати",
  "COPY_BUTTON_COPIED_TEXT": "Скопійовано",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Надіслати",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Скасувати",
  "FEEDBACK_FORM_PLACEHOLDER": "Надайте якомога більше відомостей, але не вказуйте конфіденційну інформацію.",
  "FEEDBACK_FORM_TITLE": "Поділіться своїми враженнями",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Завантажити файл '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Завантажити файл \"$1\" завбільшки $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "\"$1\" завбільшки $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Відкривається в новому вікні; зовнішнє.",
  "RECEIPT_CARD_TAX": "Податок",
  "RECEIPT_CARD_TOTAL": "Усього",
  "RECEIPT_CARD_VAT": "ПДВ",
  "REFERENCE_LIST_HEADER_ONE": "$1 посилання",
  "REFERENCE_LIST_HEADER_FEW": "$1 посилань",
  "REFERENCE_LIST_HEADER_MANY": "$1 посилань",
  "REFERENCE_LIST_HEADER_OTHER": "$1 посилання",
  "REFERENCE_LIST_HEADER_TWO": "$1 посилання",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Видалити вкладення $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Видалити",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Файл",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Зображення",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Не можна надсилати пусті повідомлення.",
  "SPEECH_INPUT_LISTENING": "Слухання…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Мікрофон вимкнуто",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Мікрофон увімкнуто",
  "SPEECH_INPUT_STARTING": "Початок…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Далі",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Назад",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Рекомендовані дії",
  "TEXT_INPUT_ALT": "Вікно вводу повідомлень",
  "TEXT_INPUT_PLACEHOLDER": "Введіть повідомлення",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Почніть говорити…",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Прослуховування…",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Обробка…",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Скажіть щось, щоб перервати…",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Надіслати",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Говорити",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Передати файл",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Клавіатура телефона",
  "TEXT_INPUT_DROP_ZONE": "Перетягніть файли",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Перевищено максимальну довжину повідомлення",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Підтримує введення лише однозначного числа",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 вкладення",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 вкладень",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 вкладення",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 вкладень",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 вкладення",
  "TOAST_ACCORDION_FEW": "Сповіщень: $1. Натисніть нижче, щоб побачити відомості",
  "TOAST_ACCORDION_MANY": "Сповіщень: $1. Натисніть нижче, щоб побачити відомості",
  "TOAST_ACCORDION_OTHER": "Сповіщень: $1. Натисніть нижче, щоб побачити відомості",
  "TOAST_ACCORDION_TWO": "Сповіщень: $1. Натисніть нижче, щоб побачити відомості",
  "TOAST_ALT_ERROR": "Помилка",
  "TOAST_ALT_INFO": "Відомості",
  "TOAST_ALT_SUCCESS": "Виконано",
  "TOAST_ALT_WARN": "Попередження!",
  "TOAST_DISMISS_BUTTON": "Закрити",
  "TOAST_TITLE_ALT": "Сповіщення",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Історія чату: натискайте клавіші зі стрілками, щоб переходити між елементами.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "історія чату",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Це інтерактивне повідомлення. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Повідомлення містить одне або кілька посилань. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Повідомлення містить рекомендовані дії. Натисніть клавіші Shift + Tab 2–3 рази, щоб вибрати їх.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Повідомлення містить рекомендовані дії. Натисніть клавішу $1, щоб вибрати їх.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Не вдалося надіслати повідомлення.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Доступні нові повідомлення. Натисніть $1, щоб встановити фокус на кнопку \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Інші повідомлення",
  "TRANSCRIPT_NEW_MESSAGES": "Нові повідомлення",
  "TRANSCRIPT_TERMINATOR_TEXT": "Кінець історії чату",
  "TYPING_INDICATOR_ALT": "Показує індикатор набору",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 вводить повідомлення.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 та інші вводять повідомлення.",
  "VIEW_CODE_BUTTON_TEXT": "Код",
  "VOTE_COMPLETE_ALT": "Відгук записано",
  "VOTE_COMPLETE_ALT.comment": "Це дані для невізуального екрана. Підпис кнопки зі значками \"Подобається\" і \"Не подобається\", який використовується для записування відгуку.",
  "VOTE_DISLIKE_ALT": "Не подобається",
  "VOTE_LIKE_ALT": "Подобається"
}